<div class="pie-chart-container">
  <h4>{{ title }}</h4>
  @if (this.pieChartData.labels?.length && this.pieChartData.datasets[0].data.length) {
    <div class="custom-chart">
      <canvas [data]="pieChartData" [type]="pieChartType" (chartClick)="chartClicked($event)" baseChart> </canvas>
    </div>
  }
  @if (!(this.pieChartData.labels?.length && this.pieChartData.datasets[0].data.length)) {
    @if (count > 0) {
      <!-- <h1>Piechart is loading...</h1> -->
      <div class="loader-container">
        <div class="loader-wrapper">
          <!-- Spinning pie chart segments -->
          <div class="spinner">
            <svg class="pie-svg" viewBox="0 0 100 100">
              <!-- Segment 1 - Blue -->
              <path d="M50,50 L50,10 A40,40 0 0,1 85,35 Z" fill="#3B82F6" opacity="0.8" />
              <!-- Segment 2 - Green -->
              <path d="M50,50 L85,35 A40,40 0 0,1 85,65 Z" fill="#10B981" opacity="0.6" />
              <!-- Segment 3 - Orange -->
              <path d="M50,50 L85,65 A40,40 0 0,1 50,90 Z" fill="#F59E0B" opacity="0.4" />
              <!-- Segment 4 - Red -->
              <path d="M50,50 L50,90 A40,40 0 0,1 15,65 Z" fill="#EF4444" opacity="0.3" />
              <!-- Segment 5 - Purple -->
              <path d="M50,50 L15,65 A40,40 0 0,1 50,10 Z" fill="#8B5CF6" opacity="0.2" />
            </svg>
          </div>

          <!-- Center circle with pulse effect -->
          <div class="center-circle"></div>

          <!-- Animated dots -->
          <div class="dots-container">
            <div class="dot dot-1"></div>
            <div class="dot dot-2"></div>
            <div class="dot dot-3"></div>
          </div>
        </div>
      </div>
    } @else {
      <div>
        {{ 'COMMON.NO_DATA' | translate }}
      </div>
    }
  }
</div>
